// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var keyframesId = "credit-flash-kf";

var anchorId = "credits-dropdown";

function formatAmountJs(amount) {
  return Number(amount).toLocaleString("en-US");
}

var toastQueue = {
  contents: /* [] */0
};

var isShowing = {
  contents: false
};

function resetCreditFlashQueueForTests() {
  toastQueue.contents = /* [] */0;
  isShowing.contents = false;
}

function ensureKeyframes() {
  var match = document.getElementById(keyframesId);
  if (!(match == null)) {
    return ;
  }
  var style = document.createElement("style");
  style.id = keyframesId;
  style.textContent = "\n    @keyframes credit-flash-slide-in {\n      from { opacity: 0; transform: translateY(-6px) scale(0.95); }\n      to   { opacity: 1; transform: translateY(0)   scale(1);    }\n    }\n    @keyframes credit-flash-slide-out {\n      from { opacity: 1; transform: translateY(0)   scale(1);    }\n      to   { opacity: 0; transform: translateY(-4px) scale(0.95); }\n    }\n  ";
  document.head.appendChild(style);
}

function makeToastItem(flashType, amount) {
  return {
          flashType: flashType,
          amount: amount
        };
}

function processQueue() {
  if (isShowing.contents || toastQueue.contents === /* [] */0) {
    return ;
  }
  var match = toastQueue.contents;
  if (!match) {
    return ;
  }
  var head = match.hd;
  toastQueue.contents = match.tl;
  isShowing.contents = true;
  showCreditFlash(head.flashType, head.amount, (function () {
          isShowing.contents = false;
          processQueue();
        }));
}

function showCreditFlash(flashType, amount, onDone) {
  ensureKeyframes();
  var anchor = document.getElementById(anchorId);
  if (anchor == null) {
    return onDone();
  }
  var rect = anchor.getBoundingClientRect();
  var isEarned = flashType === "earned";
  var sign = isEarned ? "+" : "−";
  var toast = document.createElement("div");
  toast.setAttribute("data-credit-flash-toast", "");
  var toastStyle = toast.style;
  toastStyle.position = "fixed";
  toastStyle.top = (rect.bottom + 8).toString() + "px";
  toastStyle.setProperty("right", (window.innerWidth - rect.right).toString() + "px");
  toastStyle.setProperty("zIndex", "9999");
  toastStyle.setProperty("pointerEvents", "none");
  toastStyle.setProperty("animation", "credit-flash-slide-in 0.18s ease-out forwards");
  var background = isEarned ? "rgba(234,88,12,0.18)" : "rgba(194,65,12,0.15)";
  var borderColor = isEarned ? "rgba(249,115,22,0.35)" : "rgba(234,88,12,0.25)";
  var textColor = isEarned ? "rgb(251,146,60)" : "rgb(253,186,116)";
  toast.innerHTML = "<div style=\"\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      padding: 5px 10px;\n      border-radius: 9999px;\n      font-size: 11px;\n      font-weight: 700;\n      letter-spacing: 0.02em;\n      white-space: nowrap;\n      backdrop-filter: blur(8px);\n      box-shadow: 0 4px 16px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06);\n      background: " + background + ";\n      border: 1px solid " + borderColor + ";\n      color: " + textColor + ";\n    \">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\" class=\"size-3 shrink-0\" aria-hidden=\"true\"><path d=\"M11.983 1.907a.75.75 0 0 0-1.292-.657l-8.5 9.5A.75.75 0 0 0 2.75 12h6.572l-1.305 6.093a.75.75 0 0 0 1.292.657l8.5-9.5A.75.75 0 0 0 17.25 8h-6.572l1.305-6.093Z\"/></svg>\n      <span>" + sign + Number(amount).toLocaleString("en-US") + " cr</span>\n    </div>";
  document.body.appendChild(toast);
  var finish = function () {
    toast.remove();
    onDone();
  };
  var dismiss = function () {
    toastStyle.setProperty("animation", "credit-flash-slide-out 0.25s ease-in forwards");
    DomEl$GameDataCore.onWithOptions(toast, "animationend", (function (_event) {
            finish();
          }), {
          once: true
        });
  };
  var timeout = setTimeout(dismiss, 2400);
  var observerRef = {
    contents: undefined
  };
  var observer = new MutationObserver((function () {
          if (document.body.contains(toast)) {
            return ;
          }
          clearTimeout(timeout);
          var activeObserver = observerRef.contents;
          if (activeObserver !== undefined) {
            Caml_option.valFromOption(activeObserver).disconnect();
          }
          onDone();
        }));
  observerRef.contents = Caml_option.some(observer);
  observer.observe(document.body, {
        childList: true
      });
}

function enqueueCreditFlash(flashType, amount) {
  toastQueue.contents = Belt_List.concat(toastQueue.contents, {
        hd: {
          flashType: flashType,
          amount: amount
        },
        tl: /* [] */0
      });
  processQueue();
}

function mounted() {
  var self = this ;
  self.handleEvent("credit:flash", (function (payload) {
          enqueueCreditFlash(payload.type, payload.amount);
        }));
}

var creditFlash = {
  mounted: mounted
};

var dismissMs = 2400;

export {
  keyframesId ,
  anchorId ,
  dismissMs ,
  formatAmountJs ,
  toastQueue ,
  isShowing ,
  resetCreditFlashQueueForTests ,
  ensureKeyframes ,
  makeToastItem ,
  processQueue ,
  showCreditFlash ,
  enqueueCreditFlash ,
  mounted ,
  creditFlash ,
}
/* mounted Not a pure module */
